/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { firebase } from "store/slices/firebaseSlice";

const SomaticRoute = ({ Component }) => {
  const { isAuth, showSomatics } = useSelector(firebase);
  if (!isAuth) return <Navigate to="/authentication/sign-in" />;
  if (!showSomatics) return <Navigate to="/tables" />;
  return <Component />;
};

export default SomaticRoute;
